'use strict';Object.defineProperty(exports,"__esModule",{value:true});exports.getTag=getTag;/**
 * Returns the Tag of the element
 * @param  { Object } element
 * @return { String }
 */function getTag(el){return el.tagName.toLowerCase().replace(/:/g,'\\:');}